/**
 * WPA 路徑：同步 document 的 manifest / canonical / og:url，讓 iOS「加入主畫面」能讀到每公司
 * manifest（start_url 為 /{guid}/wpa/login），而非預設 /manifest.json（start_url 為 /）。
 * 須與 public/index.html 內嵌腳本使用相同路徑規則。
 */
export const WPA_COMPANY_WPA_PATH_RE =
  /^\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\/wpa(\/|$)/;
const WPA_MANIFEST_REV = '20260411b';

function defaultManifestHref() {
  const pub = typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL != null
    ? process.env.PUBLIC_URL
    : '';
  return pub ? `${String(pub).replace(/\/$/, '')}/manifest.json` : '/manifest.json';
}

function defaultAppleTouchIconHref() {
  const pub = typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL != null
    ? process.env.PUBLIC_URL
    : '';
  return pub ? `${String(pub).replace(/\/$/, '')}/assets/logo192.png` : '/assets/logo192.png';
}

export function getWpaCompanyIdFromPathname(pathname) {
  const m = String(pathname || '').match(WPA_COMPANY_WPA_PATH_RE);
  return m ? m[1] : null;
}

/**
 * @param {string} pathname — 通常為 location.pathname（含 SPA 導向後路徑）
 */
export function syncWpaManifestHead(pathname) {
  if (typeof document === 'undefined') return;

  const companyId = getWpaCompanyIdFromPathname(pathname);

  if (companyId) {
    const href = `/api/wpa-auth/manifest/${companyId}?rev=${WPA_MANIFEST_REV}`;
    const appleIconHref = `/api/wpa-auth/company-icon/${companyId}?size=192&rev=${WPA_MANIFEST_REV}`;
    const allManifest = document.querySelectorAll('link[rel="manifest"]');
    let link = allManifest[0];
    for (let i = allManifest.length - 1; i >= 1; i -= 1) {
      allManifest[i].parentNode.removeChild(allManifest[i]);
    }
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      document.head.appendChild(link);
    }
    if (link.getAttribute('href') !== href) {
      link.setAttribute('href', href);
    }
    let appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (!appleIcon) {
      appleIcon = document.createElement('link');
      appleIcon.setAttribute('rel', 'apple-touch-icon');
      document.head.appendChild(appleIcon);
    }
    if (appleIcon.getAttribute('href') !== appleIconHref) {
      appleIcon.setAttribute('href', appleIconHref);
    }

    const loginUrl = `${window.location.origin}/${companyId}/wpa/login`;

    let canonical = document.querySelector('link[rel="canonical"][data-wpa-head]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.setAttribute('data-wpa-head', '1');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', loginUrl);

    let ogUrl = document.querySelector('meta[property="og:url"][data-wpa-head]');
    if (!ogUrl) {
      ogUrl = document.createElement('meta');
      ogUrl.setAttribute('property', 'og:url');
      ogUrl.setAttribute('data-wpa-head', '1');
      document.head.appendChild(ogUrl);
    }
    ogUrl.setAttribute('content', loginUrl);

    const ensureMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"][data-wpa-head]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        el.setAttribute('data-wpa-head', '1');
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    ensureMeta('apple-mobile-web-app-capable', 'yes');
    ensureMeta('mobile-web-app-capable', 'yes');
    ensureMeta('apple-mobile-web-app-status-bar-style', 'default');

    return;
  }

  const extras = document.querySelectorAll('link[rel="manifest"]');
  for (let i = extras.length - 1; i >= 1; i -= 1) {
    extras[i].parentNode.removeChild(extras[i]);
  }
  const def = defaultManifestHref();
  const defaultAppleIcon = defaultAppleTouchIconHref();
  let link = document.querySelector('link[rel="manifest"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'manifest';
    document.head.appendChild(link);
  }
  if (link.getAttribute('href') !== def) {
    link.setAttribute('href', def);
  }
  let appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
  if (!appleIcon) {
    appleIcon = document.createElement('link');
    appleIcon.setAttribute('rel', 'apple-touch-icon');
    document.head.appendChild(appleIcon);
  }
  if (appleIcon.getAttribute('href') !== defaultAppleIcon) {
    appleIcon.setAttribute('href', defaultAppleIcon);
  }

  document.querySelectorAll('link[rel="canonical"][data-wpa-head], meta[property="og:url"][data-wpa-head], meta[name="apple-mobile-web-app-capable"][data-wpa-head], meta[name="mobile-web-app-capable"][data-wpa-head], meta[name="apple-mobile-web-app-status-bar-style"][data-wpa-head]').forEach((el) => {
    el.parentNode.removeChild(el);
  });
}
